var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 30,
    viewBox: "0 0 74 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 22281",
    d: "M0.908698 1.5145C0.508783 0.847972 0.988896 0 1.76619 0H64.4338C64.7851 0 65.1106 0.184299 65.2913 0.485504L73.3826 13.971C73.7626 14.6044 73.7626 15.3956 73.3826 16.029L65.2913 29.5145C65.1106 29.8157 64.7851 30 64.4338 30H1.76619C0.988895 30 0.508783 29.152 0.908697 28.4855L8.3826 16.029C8.76262 15.3956 8.76262 14.6044 8.3826 13.971L0.908698 1.5145Z",
    fill: "#FDF701"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.242134d5cf2c78c5182df92388008fba.svg";
export { ForwardRef as ReactComponent };